<template>
  <div>
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">Unit</div>
        <q-space></q-space>
        <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="saveAndAddNew"
        >
          Save & Add New
        </q-btn>
        <q-btn
          :loading="isLoading"
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="save(true)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <div class="row q col-gutter-x-lg q-col-gutter-y-md">
          <div class="col-12">
            <q-card flat>
              <q-card-section>
                <div class="row q-mb-sm items-center">
                  <div class="col-6">
                    <div class="row items-center q-col-gutter-x-md">
                      <div class="col-3">
                        <div class="title q-my-none">Info</div>
                      </div>
                    </div>
                  </div>
                </div>
                <q-form ref="form">
                  <div class="row q-col-gutter-y-sm q-mb-lg q-col-gutter-x-lg">
                    <div class="col-4">
                      <q-input
                        label="Unit"
                        v-model="formData.name"
                        :rules="[(v) => !!v || 'Field is Required']"
                        hint="Displays on mouse hover on the grid field"
                      >
                      </q-input>
                    </div>
                    <div class="col-4">
                      <q-input
                        label="Unit Abbreviation"
                        v-model="formData.shortName"
                        counter
                        maxlength="8"
                        :rules="[(v) => !!v || 'Field is Required']"
                        hint="Displayed Unit on the grid"
                      ></q-input>
                    </div>
                    <div class="col-4">
                      <q-input
                        label="Help Text"
                        v-model="formData.helpText"
                        counter
                        maxlength="8"
                        hint="A text that will tell the business to refer to another website for helping with unit conversion"
                      ></q-input>
                    </div>
                  </div>
                </q-form>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    isLoading: false,
    formData: {},
  }),
  computed: {
    ...mapGetters({
      data: "units/selectedUnit",
    }),
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.init();
      },
    },
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      }
      if (this.formData.status == "temp") {
        this.formData.status = "live";
      }
    },
    async saveAndAddNew() {
      this.isLoading = true;
      await this.save();
      let result = await this.$store.dispatch("units/new", {
        status: "temp",
      });
      let id = result.Response.newUnitId;
      this.$router.push("/units/" + parseFloat(id));
      this.$store.dispatch("units/loadByID", id);
    },
    async save(isClose = false) {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        let payload = {
          id: this.$route.params.id,
          ...this.formData,
        };
        let result = await this.$store.dispatch("units/save", payload);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          if (isClose) {
            this.closeDialog();
          }
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },

    closeDialog() {
      this.$router.push("/units");
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 13px;
}
.sustainability-button {
  min-width: 151px;
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
